/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_Serial_NoInputs */

const en_admin_settings_fields_wechat_serial_no = /** @type {(inputs: Admin_Settings_Fields_Wechat_Serial_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificate Serial No`)
};

const zh_admin_settings_fields_wechat_serial_no = /** @type {(inputs: Admin_Settings_Fields_Wechat_Serial_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`证书序列号`)
};

/**
* | output |
* | --- |
* | "Certificate Serial No" |
*
* @param {Admin_Settings_Fields_Wechat_Serial_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_serial_no = /** @type {((inputs?: Admin_Settings_Fields_Wechat_Serial_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_Serial_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_wechat_serial_no(inputs)
	return zh_admin_settings_fields_wechat_serial_no(inputs)
});
export { admin_settings_fields_wechat_serial_no as "admin.settings.fields.wechat_serial_no" }